/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 *
 * Zone JS is required by Angular for zone-based change detection (see src/main.ts).
 */
import 'zone.js';